import React from "react";
import { Box } from "../../styled/Elements";
import { Controller } from "react-hook-form";
import ValidationErrorText from "./ValidationErrorText";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const ValidationController = ({
  control,
  name,
  validationConfig,
  renderer,
  errors,
  form,
}) => {
  const { t } = useTranslation();
  return (
    <ControllerWrapper>
      <Controller
        name={name}
        control={control}
        rules={validationConfig}
        render={renderer}
      />
      {errors[name]?.type === "required" && (
        <ValidationErrorText
          text={t(errors[name]?.message) || `${t(name)} ${t("isRequired")}.`}
          //   extraClass={errorDisplay}
        />
      )}
    </ControllerWrapper>
  );
};

export default ValidationController;

const ControllerWrapper = styled.div`
  width: 100%;
  .preview-box {
    position: relative;
    width: 100%;
    height: auto;
    z-index: 999;

    .default-icon.delete-icon {
      svg:hover {
        [stroke] {
          stroke: var(--redColor);
        }
      }
    }
  }

  .preview-img {
    width: 230px;
    height: 80px;
    object-fit: cover;
  }
`;
